import type { DefaultTheme } from "styled-components";

export enum COLORS {
  BLUE = "blue",
  RED = "red",
  YELLOW = "yellow",
  GREEN = "green",
  BEIGE = "beige"
}

export type IProps = {
  theme?: DefaultTheme;
  color?: string;
};

export type TagProps = {
  text: string;
  color: string;
};
